﻿import React from 'react';
import Lottie from 'lottie-react';

import { getEpiDataFromElement } from '../../../Utils/epiHelpers';
import IconHelper from '@bazooka_se/lf-icons';
import iconAnimData from '../../../AnimationFiles/illustration-twitter';

const TwitterBlock = (props) => {

    const text = getEpiDataFromElement('text', props.element) || '';
    const linkText = getEpiDataFromElement('link-text', props.element) || '';

    const lottieRef = React.useRef();
    const teaserRef = React.useRef();

    const [hovered, setHovered] = React.useState(false);
    const enter = () => setHovered(true);
    const leave = () => setHovered(false);

    React.useEffect(() => {
        const container = teaserRef.current;

        if (container) {
            container.addEventListener('mouseenter', enter);

            return () => {
                container.removeEventListener('mouseenter', enter);
            };
        }
    }, []);

    React.useEffect(() => {
        if (lottieRef) {

            if (hovered === true) {
                lottieRef.current.play();

                // timeout to ensure animation is completed despite mouseleave
                const timer = setTimeout(leave, 2000);

                return () => clearTimeout(timer);
            }
            if (hovered === false) {
                lottieRef.current.stop();
            }
        }
    }, [hovered])


    return (
        <a href="https://twitter.com/Lararforsakring" rel="noopener noreferrer" target="_blank" className="twitter block-spacing" ref={teaserRef}>
            <div className="social__container social__container--clickable">

                <div className="social__content">
                    <Lottie
                        className="social__content__icon"
                        animationData={iconAnimData}
                        lottieRef={lottieRef}
                    />
                    <h2 className="social__content__heading">Twitter</h2>

                    <span className="social__content__link__icon"
                        dangerouslySetInnerHTML={{ __html: IconHelper('angle-right').outerHTML }}>
                    </span>
                </div>

                <p className="social__text">{text}</p>

                <div className="social__link arrow-link">
                    {linkText}
                    <span
                        dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}>
                    </span>
                </div>
            </div>
        </a>
    )
}

// state

const mapStateToProps = (state) => {
    return {

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
     
    };
};

export default TwitterBlock;

